import {
  useListRolesByOrganization,
  useListOrganizations,
  useListPermissions,
} from 'api/resource';
import { useCurrentUserStore } from 'store/UserStore';

export const useUserRoleManagementData = () => {
  const { organizationID } = useCurrentUserStore();

  const rolesResult = useListRolesByOrganization({ organizationID });
  const organizationsResult = useListOrganizations({
    isAdmin: false,
    organizationID,
  });
  const permissionsResult = useListPermissions();

  const isLoading =
    rolesResult.isLoading ||
    organizationsResult.isLoading ||
    permissionsResult.isLoading;
  const isError =
    rolesResult.isError ||
    organizationsResult.isError ||
    permissionsResult.isError;
  const isFetching =
    rolesResult.isFetching ||
    organizationsResult.isFetching ||
    permissionsResult.isFetching;
  const errorMessage =
    rolesResult.error?.message ||
    organizationsResult.error?.message ||
    permissionsResult.error?.message;

  return {
    roles: rolesResult.data || [],
    organizations: organizationsResult.data || [],
    permissions: permissionsResult.data || [],
    isLoading,
    isError,
    isFetching,
    errorMessage,
  };
};
